import React, { useState } from "react";
import "./RequestQuotepage.css";
import quoteImg from "../Assessts/quote1.jpg";

const RequestQuotepage = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    companyName: "",
    phone: "",
    requirement: "",
  });

  const [alertMsg, setAlertMsg] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("Form submitted:", formData);

    // Show custom alert
    setAlertMsg("✅ Request submitted successfully! We will contact you soon.");
    setShowAlert(true);

    // Reset form fields
    setFormData({
      fullName: "",
      email: "",
      companyName: "",
      phone: "",
      requirement: "",
    });

    // Hide alert after 5 seconds
    setTimeout(() => setShowAlert(false), 5000);

    // Here you can also send data to backend API
  };

  return (
    <div className="request-quote-container">
      {/* Alert */}
      <div
        style={{
          position: "fixed",
          top: showAlert ? "20px" : "-60px",
          left: "50%",
          transform: "translateX(-50%)",
          backgroundColor: "#d4edda",
          color: "#155724",
          padding: "15px 30px",
          fontWeight: "bold",
          borderRadius: "5px",
          transition: "top 0.5s ease-in-out",
          zIndex: 1000,
        }}
      >
        {alertMsg}
      </div>

      <div className="quote-header">
        <div className="quote-image">
          <img
            src={quoteImg}
            alt="Request Quote"
            width={450}
            style={{ border: "3px solid #107b74ff", borderRadius: "10px" }}
          />
        </div>
        <div className="quote-text">
          <h1 style={{ fontWeight: "bold" }}>REQUEST A QUOTE</h1>
          <p>We'll Get Back To You With A Tailored Solution</p>
        </div>
      </div>

      <div className="quote-content">
        <form className="quote-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="fullName"
            placeholder="Full Name*"
            value={formData.fullName}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Company Email*"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="companyName"
            placeholder="Company Name*"
            value={formData.companyName}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone No.*"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <textarea
            name="requirement"
            placeholder="*Kindly Mention Product Name With Your Requirement."
            value={formData.requirement}
            onChange={handleChange}
            rows="4"
          ></textarea>

          {/* <div className="captcha">
            <span>
              <input type="checkbox" required />
            </span>{" "}
            <span>I'm not a robot</span>
          </div> */}

          <button type="submit" style={{ fontWeight: "bold" }}>
            SUBMIT NOW
          </button>
        </form>

        <div className="quote-contact-info" style={{ marginTop: "-100px" }}>
          <h3>Phone Number</h3>
          <p>+91 8595051974</p>
          <p>+91 9235352625</p>

          <h3>Email</h3>
          <p>info@taadpl.com</p>
          <p>sales@taadpl.com</p>

          <h3>Working Hours</h3>
          <p>Monday to Saturday</p>
          <p>9.30AM to 5.30PM(IST)</p>
        </div>
      </div>
    </div>
  );
};

export default RequestQuotepage;
